import React from 'react';
import CreateReactClass from 'create-react-class';

import Reactor from 'data/reactor';
import Getters from 'data/getters';
import SessionStorageUtils from './utils';
import { DeepCompareComponentShouldUpdateMixin, deepCompare } from 'utils/react';

export default CreateReactClass({
    // Observe changes to partner, runtime, user, and roster stores and
    //      update session storage.
    //
    // Intentionally ignore the student and learning-continuum stores:
    //     students are stored individually, so the store does not get persistent to session storage
    //     learning continuum data is too large for session storage, so it just gets wiped out on
    //            refresh
    displayName: 'session-storage-manager',
    mixins: [Reactor.ReactMixin, DeepCompareComponentShouldUpdateMixin],

    getDataBindings() {
        return {
            partnerStore: Getters.partner.fullStore,
            runtimeStore: Getters.runtime.fullStore,
            rosterStore: Getters.roster.fullStore,
            userStore: Getters.user.fullStore,
        };
    },

    componentDidMount() {
        this.updateSessionStorage();
    },

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        const stores = [];
        if (!deepCompare(nextState.partnerStore, this.state.partnerStore)) {
            stores.push(SessionStorageUtils.PARTNER_STORE);
        }
        if (!deepCompare(nextState.runtimeStore, this.state.runtimeStore)) {
            stores.push(SessionStorageUtils.RUNTIME_STORE);
        }
        if (!deepCompare(nextState.rosterStore, this.state.rosterStore)) {
            stores.push(SessionStorageUtils.ROSTER_STORE);
        }
        if (!deepCompare(nextState.userStore, this.state.userStore)) {
            stores.push(SessionStorageUtils.USER_STORE);
        }
        this.updateSessionStorage(stores);
    },

    updateSessionStorage(
        stores = [
            SessionStorageUtils.RUNTIME_STORE,
            SessionStorageUtils.PARTNER_STORE,
            SessionStorageUtils.ROSTER_STORE,
            SessionStorageUtils.USER_STORE,
        ]
    ) {
        SessionStorageUtils.saveStores(stores);
    },

    render() {
        return null;
    },
});
